"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
// 文章分类选择器组件
var _default = exports.default = {
  name: 'SArticleCate',
  components: {},
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: _vueTypes.default.integer.def(-1)
  },
  data: function data() {
    return {
      // 正在加载
      isLoading: false,
      // 分类列表
      categoryList: [],
      // 选择的分类ID
      selectedId: -1
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler: function handler(val) {
        this.selectedId = val;
      }
    }
  },
  created: function created() {
    // 获取分类列表
    this.getCategoryList();
  },
  methods: {
    /**
     * 获取分类列表
     */
    getCategoryList: function getCategoryList() {
      var _this = this;
      this.isLoading = true;
      categoryApi.treeCategroy({
        type: 3,
        status: 1
      }).then(function (result) {
        var source = Array.isArray(result) ? result : result && result.list ? result.list : [];
        _this.categoryList = _this.flattenTree(source);
      }).finally(function (result) {
        _this.isLoading = false;
      });
    },
    flattenTree: function flattenTree() {
      var _this2 = this;
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      nodes.forEach(function (item) {
        list.push({
          category_id: item.id,
          name: item.name
        });
        if (item.child && item.child.length) {
          list.push.apply(list, _toConsumableArray(_this2.flattenTree(item.child)));
        }
      });
      return list;
    },
    // 触发change事件
    onChange: function onChange(value) {
      this.$emit('change', value);
    }
  }
};